'use strict';

const { get, isEmpty } = require('lodash');

const $cache = {
    body: $('body'),
};

const initAddToCartSuccessCarousel = () => {
    $cache.$recommendedProductCarousel = $cache.body.find('.frequently-bought-together');

    if (!$cache.$recommendedProductCarousel.hasClass('slick-initialized')) {
        $cache.$recommendedProductCarousel.slick({
            dots: false,
            arrows: true,
            infinite: false,
            speed: 200,
            touchThreshold: 100,
            slidesToShow: 1.8,
            slidesToScroll: 1,
            nextArrow: '<button type="button" class="slick-next"><i class="icon icon-arrow-forward icon-size-xl"></i></button>',
            prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-arrow-back icon-size-xl"></i></button>',
            responsive: [
                {
                    breakpoint: window.app.grid.lg,
                    settings: {
                        slidesToShow: 2.4,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: window.app.grid.md,
                    settings: {
                        slidesToShow: 1.2,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }
};

const closeToaster = ($toaster, atbLabel) => {
    $toaster.find('.close-toaster').on('click', () => {
        $toaster.addClass('d-none');
        $cache.body.find('.toaster-backdrop').remove();

        $cache.body.find('.frequently-bought-together .product').each((idx, product) => {
            const $tile = $(product);
            $tile.find('.atb-msg-container').addClass('d-none');
            $tile.find('.add-to-cart-global span').text(atbLabel);
        });
    });
};

/**
 * Init Toaster
 */
const initSuccessToaster = () => {
    let carouselAddToCartBtnPid = '';

    $cache.body.on('product:afterAddToCart', (e, data) => {
        e.preventDefault();
        e.stopPropagation();

        const isError = !!get(data, 'error');
        const successToaster = get(data, 'addedProductToaster', {});
        if (!isEmpty(successToaster) && !isEmpty(successToaster.template) && !isError) {
            const $successToaster = $('.product-add-to-cart-success-toaster');
            $successToaster.removeClass('d-none');
            $successToaster.find('.add-to-cart-success-toaster-body').empty().append(successToaster.template);

            if (!$cache.body.find('.toaster-backdrop').length) {
                if (!$('.wishlist-page-wrapper').length) {
                    $cache.body.append('<div class="toaster-backdrop modal-backdrop fade show"></div>');
                }
            }

            closeToaster($successToaster, get(successToaster, 'details.atbLabel', ''));
            initAddToCartSuccessCarousel();

            $cache.body.on('product:beforeAddToCart', (event, button) => {
                carouselAddToCartBtnPid = $(button).attr('data-pid');
            });
            $cache.body.on('updateAddToCartFormData', (_, form) => {
                form.pid = carouselAddToCartBtnPid;
            });
            $cache.body.find('.frequently-bought-together .product').each((idx, product) => {
                const $tile = $(product);
                const $atb = $tile.find('.add-to-cart-global');
                const item = get(data, 'cart.items', []).find((i) => i.id === $tile.attr('data-pid'));

                if (item && get(item, 'quantity') === get(item, 'quantityOptions.maxOrderQuantity')) {
                    $atb.attr('disabled', true);
                }
                if ($tile.attr('data-pid') === carouselAddToCartBtnPid) {
                    $tile.find('.atb-msg-container').removeClass('d-none');

                    $atb.find('span').text(get(successToaster, 'details.addOneMoreLabel', ''));
                }
            });
        }
    });
};

module.exports = {
    methods: {
        initSuccessToaster,
    },
};
